import { Pipe, PipeTransform } from '@angular/core';
import { PendingDocument } from 'src/app/shared/models/pending-document.model';

@Pipe({
  name: 'filtroTipoDocumento',
  pure: false
})
export class FiltroTipoDocumentoPipe implements PipeTransform {

  transform(lista: PendingDocument[], tipoDocumento: number = 0, nifFiltrado: string = ""): any[] {
    
    if (!lista) {
      return [];
    }
    
    lista = lista.filter( l => l.tipoDocumento == tipoDocumento && l.nifDocumento == nifFiltrado);

    return lista;
  }

}
